import OmNetSearch from './OmNetSearch';

document.addEventListener('DOMContentLoaded', () => {
  new OmNetSearch();
});
